import OneTrustPlaceholder from './OneTrustPlaceholder';

export default OneTrustPlaceholder;
